export default {
  methods: {
    moneyFormat(money, currency = "USD") {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
      }).format(money);
    },
  },
};
